import React from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyTierPill from 'loyalty/components/LoyaltyTierPill'
import TextLink from 'LuxKit/TextLink'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import TriplePointTakeoverLogo from './TriplePointTakeoverLogo'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Clickable from 'components/Common/Clickable'

const Span = styled(Clickable)`
  display: inline-grid;
  grid-template: 1ex / auto;
  place-items: center;
  vertical-align: middle;
  overflow: visible;
`

function TriplePointTakeoverSearchBanner() {
  const [tier] = useCurrentLoyaltyTier()
  return <Group direction="horizontal" gap={20} verticalAlign="center">
    <CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>
    <VerticalSpacer gap={2}>
      <Heading variant="heading3">Your next trip just got <i>3x</i> better</Heading>
      <CSSBreakpoint max="mobile">
        <Group direction="horizontal" gap={8} wrap="wrap">
          <BodyText variant="large">
            Look for <Span to="/triple-points"><LoyaltyTierPill kind="primary" tier={tier}>Triple Points</LoyaltyTierPill></Span>{' '}
          </BodyText>
          <TextLink size="large" to="/triple-points" weight="regular">View all offers</TextLink>
        </Group>
      </CSSBreakpoint>
      <CSSBreakpoint min="tablet">
        <BodyText variant="large">
          Look for <Span to="/triple-points"><LoyaltyTierPill kind="primary" tier={tier}>Triple Points</LoyaltyTierPill></Span>{' '}
          on select packages! Hurry, limited time only. <TextLink to="/triple-points">View all offers</TextLink>
        </BodyText>
      </CSSBreakpoint>
    </VerticalSpacer>
  </Group>
}

export default TriplePointTakeoverSearchBanner
